"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FormControlLabel = exports.ExpandMoreIcon = exports.Item = exports.Title = void 0;
const tslib_1 = require("tslib");
const styled_components_1 = (0, tslib_1.__importDefault)(require("styled-components"));
const core_1 = require("@material-ui/core");
const icons_1 = require("@material-ui/icons");
exports.Title = (0, styled_components_1.default)(core_1.Typography) `
  font-size: 16px;
  font-family: 'ATTAleckSansMd';
`;
exports.Item = styled_components_1.default.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0;
`;
exports.ExpandMoreIcon = (0, styled_components_1.default)(icons_1.ExpandMore) `
  color: black;
`;
exports.FormControlLabel = (0, styled_components_1.default)(core_1.FormControlLabel) `
  height: 30px;
  .MuiTypography-body1 {
    font-size: 13px;
    font-family: 'ATTAleckSans';
  }
`;
